import React from 'react';
import styled from 'styled-components/macro';
import { Title, Body, Flex } from '@cognite/cogs.js';
import type { IconType } from '@cognite/cogs.js';
import { Milestone } from 'types/dt-graphql-apollo-v2';
import { ProgressBar } from 'components';
import { Icon } from 'components/Icon';
import {
  getCollectionHistoryDifference,
  getCollectionRunValidPercentage,
  getDiffArrowDirection,
  getResultColorVariantFromValue,
  getResultColorFromPercentage,
} from 'utils/runStatistics';

type CollectionStatsProps = {
  collection: Milestone;
  showDifference?: boolean;
};

export const CollectionStatistics = ({
  collection,
  showDifference = false,
}: CollectionStatsProps) => {
  if (!collection) return <></>;

  const recentRunResult = getCollectionRunValidPercentage(collection, 0);
  const collectionDifference = getCollectionHistoryDifference(collection);
  const iconType: IconType = getDiffArrowDirection(collectionDifference);
  const labelVariant = getResultColorVariantFromValue(collectionDifference);
  const trackColor = getResultColorFromPercentage(recentRunResult);
  const changePercentageColor = recentRunResult < 50 || recentRunResult >= 90;

  return (
    <Flex className="collection-statistics" direction="column" gap={5}>
      <Flex direction="row" alignItems="center" gap={5}>
        {showDifference &&
          !!collectionDifference &&
          collectionDifference !== 0 && (
            // Label not available in COGS v9 → using Icon as fallback
            <Icon type={iconType as any} />
          )}
        <StyledTitle
          level={4}
          style={{ color: changePercentageColor ? trackColor : 'black' }}
        >
          {parseFloat(recentRunResult.toFixed(2))}%
        </StyledTitle>
        <Body level={4}>valid data</Body>
      </Flex>
      <ProgressBar trackColor={trackColor} value={recentRunResult} />
    </Flex>
  );
};

const StyledTitle = styled(Title)`
  overflow: hidden;
  text-overflow: ellipsis;
`;
